import { Info } from 'lucide-react';
import { EsporaiTooltip } from 'components';

const AnalyticsMetricCard = ({
  title,
  value = 0,
  prefix = '',
  suffix = '',
  loading = false,
  tooltip = null,
}) => {
  const formatValue = (v) => {
    if (v === null || v === undefined) return '0';
    return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
  };

  return (
    <div className="backdrop-blur-xl bg-slate-800/90 border border-white/20 rounded-lg sm:rounded-xl md:rounded-xl p-1.5 sm:p-2 md:p-3 flex flex-col items-center justify-center space-y-0.5 sm:space-y-1 md:space-y-2 shadow-lg hover:shadow-xl hover:bg-slate-700/90 hover:border-white/30 transition-all duration-500 ease-out">
      {loading ? (
        <div className="text-center w-full">
          <div className="h-2.5 sm:h-3 md:h-3.5 bg-white/20 rounded w-3/4 mx-auto mb-0.5 sm:mb-1 animate-pulse" />
          <div className="h-3 sm:h-3.5 md:h-4 bg-white/20 rounded w-1/2 mx-auto animate-pulse" />
        </div>
      ) : (
        <div className="text-center flex flex-col items-center w-full min-w-0">
          <div className="flex items-center justify-center gap-0.5 text-[10px] sm:text-xs md:text-sm font-semibold text-white">
            <span>{title}</span>
            {tooltip && (
              <EsporaiTooltip position="top" content={tooltip} inverse>
                <button className="p-0.5 hover:text-gray-200 focus:outline-none">
                  <Info className="w-3 h-3 sm:w-4 sm:h-4 text-white opacity-70 hover:opacity-100 transition-opacity" />
                </button>
              </EsporaiTooltip>
            )}
          </div>
          <p className="text-xs sm:text-sm md:text-lg font-bold text-white truncate max-w-full">
            {prefix}
            <span className="ml-1">{formatValue(value)}</span>
            {suffix}
          </p>
        </div>
      )}
    </div>
  );
};

export default AnalyticsMetricCard;
